<template>
  <div>
    <div class="col-xs-12 mt-20 mb-20 d-flex flex-between pl-25 pr-25 complete_wrapper">
      <div class="notifications_header_alert_menu_wrapper">
    <div class="notifications_header">{{$t('notifications')}}</div>
      <div class="alert-menu">
        <div class="date_picker_box date-fields">
          <date-picker
            :editable="true"
            :disabled-date="notBeforeEndDate"
            v-model="startAlertDate"
            :default-value="startAlertDate ? startAlertDate: new Date()"
            :lang="this.$i18n.locale === 'English' ? getEnglishPicker : getPortuguesePicker"
            type="date"
            :placeholder="this.$i18n.locale === 'English' ?$t('englishDatePlaceholder') :$t('portugueseDatePlaceholder')"
            :format="formatStartDate"
            v-on:change="isValidStartDate()"
          >
          <i slot="icon-calendar">
            <img src="/static/images/icons/date-picker-calender-icon.svg" alt="calender-icon">
          </i></date-picker>

          <div class="start-to-end">{{$t('toNotifications')}}</div>
          <date-picker
            :editable="true"
            :disabled-date="notBeforeStartDate"
            v-model="endAlertDate"
            :default-value="endAlertDate ? endAlertDate : new Date()"
            :lang="this.$i18n.locale === 'English' ? getEnglishPicker : getPortuguesePicker"
            type="date"
            :placeholder="this.$i18n.locale === 'English' ?$t('englishDatePlaceholder') :$t('portugueseDatePlaceholder')"
            :format="formatEndDate"
            v-on:change="isValidEndDate()"
          >
          <i slot="icon-calendar">
            <img src="/static/images/icons/date-picker-calender-icon.svg" alt="calender-icon">
          </i></date-picker>
        </div>
      </div>
      </div>
      <div class="col-xs-12 col-md-12 col-sm-12 tabs-main pr-0 pl-0">
          <div class="col-xs-12 col-md-12 col-sm-12 main-tabs p-0">
            <div v-if="addedServices.indexOf(1) > -1" class="pr-2" @click="setTab('registration-tracker')">
              <div :class="notifTabActiveName === 'registration-tracker' ? 'active_progress_bar' : ''">
                <div
                  class="ul-new-font cursor-pointer pb-11"
                  :class="
                    notifTabActiveName === 'registration-tracker' ? 'active-text' : 'in-active-text'
                  "
                >
                  {{$t('compliance')}} {{$t('tracker')}} ({{this.regTrackerCount}})
                </div>
              </div>
            </div>
            <div class="pl-2" @click="setTab('general-notifications')">
              <div
                :class="
                  notifTabActiveName === 'general-notifications' ? 'active_progress_bar' : ''
                "
              >
                <div
                  class="ul-new-font cursor-pointer pb-11"
                  :class="
                    notifTabActiveName === 'general-notifications'
                      ? 'active-text'
                      : 'in-active-text'
                  "
                >
                  {{$t('generalNotifications')}} ({{this.generalNotificationsCount}})
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 details pl-25 pr-25">
      <p class="m-0">{{$t('details')}}</p>
    </div>
    </div>
  <!-- <div class="col-xs-12 pl-25 pr-30">
    <ul class="horizontal-tabs d-flex p-0 mt-10 mb-0"> -->
      <!-- <li v-if="addedServices.indexOf(1) > -1"
        @click="setTab('registration-tracker')"
        class="cursor-pointer" :class="{active: notifTabActiveName === 'registration-tracker',
          'tab-bold': tabHighlightCount.registration_tracker_count > 0
        }"
      >{{$t('compliance')}} {{$t('tracker')}} ({{this.regTrackerCount}})
      </li> -->
      <!-- <li v-if="addedServices.indexOf(4) > -1"
        @click="setTab('regulatory-watch')"
        class="cursor-pointer" :class="{active: notifTabActiveName === 'regulatory-watch',
          'tab-bold': tabHighlightCount.regulatory_watch_count > 0
        }"
      >Regulatory Watch ({{this.regWatchCount}})
      </li> -->
      <!-- <li v-if="addedServices.indexOf(3) > -1"
        @click="setTab('smart-builder')"
        class="cursor-pointer" :class="{active: notifTabActiveName === 'smart-builder',
          'tab-bold': tabHighlightCount.smart_builder_count > 0
        }"
      >Smart Builder ({{this.smartBuilderCount}})
      </li> -->
      <!-- <li v-if="roleId !== 4 && roleId !== 6 && showSEFlag"
        @click="setTab('smart-exchange')"
        class="cursor-pointer" :class="{active: notifTabActiveName === 'smart-exchange',
          'tab-bold': tabHighlightCount.smart_exchange_count > 0
        }"
      >Smart Exchange ({{this.smartExchangeCount}})
      </li> -->
      <!-- <li
        @click="setTab('general-notifications')"
        class="cursor-pointer" :class="{active: notifTabActiveName === 'general-notifications',
          'tab-bold': tabHighlightCount.general_notifications_count > 0
        }"
      >{{$t('generalNotifications')}} ({{this.generalNotificationsCount}})
      </li> -->
    <!-- </ul>
  </div> -->
  </div>
</template>

<script>
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import EventBus from '../../utils/event-bus';
import translation from '../UIComponents/mixins/translationMixins';

export default {
  props: ['notificationTabName', 'addedServices', 'notificationsCount', 'notificationsStarMarkCount', 'startDate', 'endDate', 'loaderStatus', 'roleId', 'showSEFlag'],
  components: {
    DatePicker,
  },
  mixins: [translation],
  data() {
    return {
      formatStartDate: {
        stringify: (date) => (date ? moment(date).format(this.$i18n.locale === 'Portuguese' ? 'DD/MM/YYYY' : 'MM/DD/YYYY') : null),
        parse: (value) => {
          const date = moment(value, this.$i18n.locale === 'Portuguese' ? 'DD/MM/YYYY' : 'MM/DD/YYYY');
          if (!date.isValid()) {
            this.startAlertDate = '';
            this.InvalidDate = true;
            this.$notify({
              type: 'error',
              title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
              text:
                this.$i18n.locale === 'Portuguese'
                  ? 'Insira uma data de início válida'
                  : 'Please enter valid start date',
              group: 'custom-notification'
            });
            return '';
          }
          this.InvalidDate = false;
          // eslint-disable-next-line no-underscore-dangle
          return value ? moment(date)._d : null;
        },
      },
      formatEndDate: {
        stringify: (date) => (date ? moment(date).format(this.$i18n.locale === 'Portuguese' ? 'DD/MM/YYYY' : 'MM/DD/YYYY') : null),
        parse: (value) => {
          const date = moment(value, this.$i18n.locale === 'Portuguese' ? 'DD/MM/YYYY' : 'MM/DD/YYYY');
          if (!date.isValid()) {
            this.EndAlertDate = '';
            this.InvalidDate = true;
            this.$notify({
              type: 'error',
              title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
              text:
                this.$i18n.locale === 'Portuguese'
                  ? 'Insira uma data de término válida'
                  : 'Please enter valid end date',
              group: 'custom-notification'
            });
            return '';
          }
          this.InvalidDate = false;
          // eslint-disable-next-line no-underscore-dangle
          return value ? moment(date)._d : null;
        },
      },
      smartBuilderCount: 0,
      smartExchangeCount: 0,
      tabHighlightCount: '',
      regWatchCount: 0,
      regTrackerCount: 0,
      generalNotificationsCount: 0,
      addedService: [],
      notifTabActiveName: 'registration-tracker',
      startAlertDate: '',
      endAlertDate: '',
      elementDefault: '',
      showStartDateMessage: false,
      showEndDateMessage: false,
      InvalidDate: false,
    };
  },
  watch: {
    notificationsStarMarkCount() {
      this.tabHighlightCount = this.notificationsStarMarkCount;
    },
    notificationsCount() {
      this.generalNotificationsCount = 0;
      Object.keys(this.notificationsCount).forEach((key) => {
        if (key === '1') { // Reg Tracker
          this.regTrackerCount = this.notificationsCount[key];
        } else if (key === '3') { // SB
          this.smartBuilderCount = this.notificationsCount[key];
        } else if (key === '4') { // Reg Watch
          this.regWatchCount = this.notificationsCount[key];
        } else if (key === 'sx_notification') { // SX
          this.smartExchangeCount = this.notificationsCount[key];
        } else if (key === 'other_notifications' || key === '6' || key === '7') { // General Notifications
          this.generalNotificationsCount += this.notificationsCount[key];
        }
      });
    },
    // startDate() {
    //   this.startAlertDate = this.startDate;
    // },
    // endDate() {
    //   this.endAlertDate = this.endDate;
    // },
    // notificationTabName() {
    //   console.log('in here');
    //   this.notifTabActiveName = this.notificationTabName;
    // },
  },
  methods: {
    // validateService(serviceId) {
    //   const validService = this.addedServices.find((value) => value === serviceId);
    //   return typeof validService !== 'undefined';
    // },
    isValidStartDate() {
      const time1 = this.startAlertDate ? moment(this.startAlertDate).format('YYYY-MM-DD') : '';
      const time2 = this.endAlertDate ? moment(this.endAlertDate).format('YYYY-MM-DD') : '';
      if (time1 && time2 && time1 > time2) {
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text:
            this.$i18n.locale === 'Portuguese'
              ? 'Insira a data de início menor ou igual à data de término'
              : 'Please enter start date less than or equal to end date',
          group: 'custom-notification'
        });
        return;
      }
      this.$emit('update:startDate', this.startAlertDate);
    },
    isValidEndDate() {
      const time1 = this.startAlertDate ? moment(this.startAlertDate).format('YYYY-MM-DD') : '';
      const time2 = this.endAlertDate ? moment(this.endAlertDate).format('YYYY-MM-DD') : '';
      if (time1 && time2 && time2 < time1) {
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text:
            this.$i18n.locale === 'Portuguese'
              ? 'Insira uma data final maior ou igual à data inicial'
              : 'Please enter end date greater than or equal to start date',
          group: 'custom-notification'
        });
        return;
      }
      this.$emit('update:endDate', this.endAlertDate);
    },
    defaultStartAndEndDates() {
      const todayDate = new Date();
      const oneMonthOldDate = new Date();
      oneMonthOldDate.setMonth(oneMonthOldDate.getMonth() - 1);
      this.startAlertDate = oneMonthOldDate;
      this.endAlertDate = todayDate;
    },

    setTab(tabName) {
      if (this.notifTabActiveName !== tabName) {
        this.notifTabActiveName = tabName;
        this.$emit('update:notificationTabName', this.notifTabActiveName);
        if (!this.startAlertDate || !this.endAlertDate) {
          this.defaultStartAndEndDates();
          this.$emit('update:startDate', this.startAlertDate);
          this.$emit('update:endDate', this.endAlertDate);
        }
      }
    },

    notBeforeEndDate(date) {
      if (this.endAlertDate) return date > new Date(this.endAlertDate).setHours(0, 0, 0, 0);
      return date > new Date().setHours(0, 0, 0, 0);
    },
    notBeforeStartDate(date) {
      return date < new Date(this.startAlertDate).setHours(0, 0, 0, 0);
    },

  },
  created() {
    this.defaultStartAndEndDates();
  },
  beforeDestroy() {
    EventBus.$off('regTrackerCount');
    EventBus.$off('regWatchCount');
    EventBus.$off('generalNotificationsCount');
    EventBus.$off('userNewNotificationsCount');
    EventBus.$off('notificationSBCount');
    EventBus.$off('notificationSXCount');
  },
  mounted() {
    EventBus.$on('regTrackerCount', (regTrackerCount) => {
      this.regTrackerCount = regTrackerCount;
    });
    EventBus.$on('regWatchCount', (regWatchCount) => {
      this.regWatchCount = regWatchCount;
    });
    EventBus.$on('notificationSBCount', (sbCount) => {
      this.smartBuilderCount = sbCount;
    });
    EventBus.$on('notificationSXCount', (sxCount) => {
      this.smartExchangeCount = sxCount;
    });
    EventBus.$on('generalNotificationsCount', (generalNotificationsCount) => {
      this.generalNotificationsCount = generalNotificationsCount;
    });
    EventBus.$on('userNewNotificationsCount', (notificationStarCount) => {
      this.tabHighlightCount = notificationStarCount;
    });
  },
};
</script>
<style>
.mx-datepicker>>>.mx-input-wrapper .mx-icon-clear {
      left: 10px;
      height: 16px;
      width: 16px;
    }
.date-fields .mx-datepicker >>> .mx-input {
  border: 0.5px solid #000000;
  padding-left: 36px;
}
.date-fields .mx-datepicker >>> .mx-input::placeholder {
  color: rgba(0, 0, 0, 0.5);
}
.date-fields .mx-datepicker >>> .mx-input-wrapper .mx-icon-calendar {
  left: 6px;
  right: auto;
}
.date_picker_box .mx-datepicker .mx-input {
  border: 1px solid #4D4D4D !important;
  border-radius: 3px !important;
  color: #1A1A1A  !important;
  font-size: 16px !important;
  line-height: 18px !important;
  padding: 8px 0px 8px 42px !important;
  font-weight: 400 !important;
}
.date_picker_box .mx-datepicker .mx-input::-webkit-input-placeholder {
  color: #1A1A1A !important;
  font-weight: 400 !important;
}
</style>
<style scoped>
.notifications_header_alert_menu_wrapper {
  display: flex;
  justify-content: space-between;
  padding-bottom: 12px;
  padding-top: 26px;
}
.complete_wrapper {
  flex-direction: column;
  margin-bottom: 0px;
  margin-top: 0px !important;
  background: #EBEBEB;
}
.main-tabs {
  background: #f5f5f5;
  padding: 11px 0px 0px 11px;
  display: flex;
  column-gap: 24px;
}
.details {
  height: 48px;
  display: flex;
  align-items: center;
  background: #E6E6E6;
  color: #3E3E3E;
  font-size: 16px;
  font-weight: 600;
}
.active_progress_bar {
  border-bottom: 2px solid #00518a;
}
.pb-11 {
  padding-bottom: 9px;
}
.active-text {
  color: #000001;
}
.in-active-text {
  color: #3e3e3e;
}
.notifications_header {
  font-size: 24px;
  color: #3E3E3E;
  font-weight: 400;
  line-height: 34px;
  padding-bottom: 8px;
}
.horizontal-tabs li{
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 25px;
  color: #3E3E3E;
}
.pr-30{
  padding-right: 30px;
}
.alert-menu .mx-datepicker {
  width: 130px;
}

.alert-menu {
  margin-top: 0px;
  padding-bottom: 8px;
}

/* .pr-25 {
  padding-right: 25px;
} */

.date_picker_box .mx-datepicker {
  width: 144px;
}

.date_picker_box .mx-datepicker >>> .mx-input {
  padding: 8px 16px 8px 34px;
  font-size: 14px;
  color: #000000;
  border: 1px solid #ccc;
  border-radius: 3px;
  font-weight: 300;
}

.date_picker_box .mx-datepicker >>> .mx-input-wrapper .mx-icon-calendar {
  left: 12px;
  right: auto;
}

.date_picker_box .mx-datepicker >>> .mx-input-wrapper .mx-icon-clear {
  right: 116px;
}

.start-to-end {
  font-size: 18px;
  font-weight: 300;
  color: #000;
  padding: 5px 16px;
  display: inline;
}

.new-calender .mx-datepicker-body {
  background: red;
}

.tab-bold {
  font-weight: 500;
  color: #00518A;
}

@media only screen and (max-width: 576px) {

  .flex-between {
    flex-direction: column;
    row-gap: 24px;
  }
}
</style>
